import requireLoggedInUser from '@client/containers/requireLoggedInUser';
import { compose } from 'recompose';
import { SubscriptionHubPage } from './component';

export const SubscriptionHubContainer = compose(requireLoggedInUser)(SubscriptionHubPage);
